import {
	SELECTED_COMPANY,
	SELECTED_COMPANY_DATA,
	SELECTED_SUB_COMPANY,
	RESET_COMPANY
} from './actions';

let defaultState = {
	selectedCompany: null,
	selectedCompanyData: {},
	selectedSubCompany: {}
};

export default function company(state = defaultState, action) {
	switch(action.type) {
		case SELECTED_COMPANY:
			return {
				...state,
				selectedCompany: action.data.selectedCompany
			};
		case SELECTED_COMPANY_DATA:
			return {
				...state,
				selectedCompanyData: action.data.selectedCompanyData
			};
		case SELECTED_SUB_COMPANY:
			return {
				...state,
				selectedSubCompany: action.data.selectedSubCompany
			};
		case RESET_COMPANY:
			return defaultState;
		default:
			return state;
	}
}